// @ts-nocheck
import editingSVG from '@plone/volto/icons/editing.svg';
import EditEventRegistrationForm from '../components/Blocks/EventRegistrationForm/EditEventRegistrationForm';
import { EVENT_REGISTRATION_FORM_BLOCK_ID } from '../components/Blocks/EventRegistrationForm/defaults';
import { eventRegistrationFormMessages } from '../components/Blocks/EventRegistrationForm/messages';

const eventRegistrationFormBlock = (config: any) => {
  const baseForm = config.blocks.blocksConfig.schemaForm;
  if (!baseForm) return config;
  config.blocks.blocksConfig[EVENT_REGISTRATION_FORM_BLOCK_ID] = {
    ...baseForm,
    id: EVENT_REGISTRATION_FORM_BLOCK_ID,
    // Single source for the chooser title (string, not a descriptor: Volto's
    // BlockChooser calls .toLowerCase() on it when filtering, #1662).
    title: eventRegistrationFormMessages.blockTitle.defaultMessage,
    icon: editingSVG,
    group: 'content',
    edit: EditEventRegistrationForm, // morph shim
    view: baseForm.view, // never reached (block morphs before view)
    restricted: false,
    mostUsed: false,
  };
  return config;
};
export default eventRegistrationFormBlock;
